// Module
var code = "<template> <li if.bind=\"visible\" class=\"popup-menu-item\" click.delegate=\"click({e: $event})\"> <div class=\"popup-menu-icon ${icon} icon\"></div> <div class=\"popup-menu-label\" title=\"${label}\">${label}</div> </li> </template> ";
// Exports
export default code;